"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "UploadErrorForm", {
  enumerable: true,
  get: function get() {
    return _UploadErrorForm["default"];
  }
});
var _UploadErrorForm = _interopRequireDefault(require("./UploadErrorForm"));